module.exports = {

  init () {

    this.cookie();

  },
  
  
  cookie() {
    $(document).ready(function(){
      $.cookieBar({
      message: "This website uses cookies to ensure you get the best experience on our website. For more information visit our <a href='/cookies-policy'>Cookies Policy</a>.",
      acceptText: "I'm happy with that",
      fixed: true,
      policyButton: false,
      policyText: "Find out more",
      policyURL: "/cookies-policy"
    });
    });  
  
  },
  
  
  

}
